module.exports = __webpack_public_path__ + "img/Employee-Feedback.4a3e8cb8.png";